import type { ScopedThreadRef } from "@cmmd-forge/contracts";
import { useEffect, useState } from "react";

import type { RemoteRuntimeConnectionState } from "../components/chat/remoteRuntimeThreadConnection.logic";
import { useComposerDraftStore } from "../composerDraftStore";

export function useRetainedLocalThreadSurface(input: {
  readonly observedConnectionState: RemoteRuntimeConnectionState;
  readonly routeThreadRef: ScopedThreadRef;
}): {
  readonly hasObservedLiveConnection: boolean;
  readonly hasStagedSubmission: boolean;
} {
  const routeTargetKey = `${input.routeThreadRef.environmentId}:${input.routeThreadRef.threadId}`;
  const [lastLiveRouteTargetKey, setLastLiveRouteTargetKey] = useState<string | null>(null);
  const hasStagedSubmission = useComposerDraftStore(
    (store) => store.getComposerDraft(input.routeThreadRef)?.stagedSubmission != null,
  );

  useEffect(() => {
    if (input.observedConnectionState.kind === "live") {
      setLastLiveRouteTargetKey(routeTargetKey);
    }
  }, [input.observedConnectionState.kind, routeTargetKey]);

  return {
    hasObservedLiveConnection: lastLiveRouteTargetKey === routeTargetKey,
    hasStagedSubmission,
  };
}
